module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VGGyumaoM-40562afde01a00cb9efbf79077d80500.png";